import React from "react";
import PropTypes from "prop-types";
import { getEl } from "../../utils/app-helpers";

export default class BookmarkScroll extends React.Component {
  scrollToBookmark = (e) => {
    e.preventDefault();
    if (typeof window === "undefined") return;
    const { bookmark } = this.props;
    const targetEl = getEl(`#${bookmark}`);

    if (!targetEl) return;
    window.scrollInterval = setInterval(() => {
      const winY = window.scrollY;
      const targetY = targetEl.offsetTop - (this.props.offset || 0);
      const diffY = targetY - winY;
      let newY = winY + Math.ceil(diffY / 4);

      if (Math.abs(newY - winY) <= 1) {
        newY = targetY;
        clearInterval(window.scrollInterval);
      }
      window.scrollTo(window.scrollX, newY);
    }, 50);
  };

  render() {
    return (
      <span className="bookmark-scroll" onClick={this.scrollToBookmark}>
        {this.props.children}
      </span>
    );
  }
}

BookmarkScroll.propTypes = {
  bookmark: PropTypes.string,
  offset: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/partials/bookmark-scroll.js